import logo from './logo.svg';
import './App.css';
import {NavBar} from './components/NavBar';
import  {Banner}  from './components/Banner';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Skills } from './components/Skills';
import { Projects } from './components/Project1';
import { Footer } from './components/Footer';
import ContactUs from './components/contact';





  

function App() {
  return (
    <div className="App">

     <NavBar/>
     <Banner/>
     <Skills/>
     <Projects/>
     <ContactUs/>
     <Footer/>
     
      
      
    </div>
  );
}

export default App;
